import { useEffect, useRef, useState } from 'react';

const WA_LINK = 'https://wa.me/5547984929295?text=Ol%C3%A1%2C%20gostaria%20de%20entender%20meu%20caso.';

const areas = [
  {
    icon: 'ri-file-list-3-line',
    title: 'Divórcios',
    desc: 'Consensual ou litigioso, judicial ou extrajudicial.',
    image: 'https://readdy.ai/api/search-image?query=elegant%20minimalist%20legal%20document%20with%20wedding%20ring%20on%20wooden%20desk%2C%20warm%20lighting%2C%20soft%20beige%20and%20cream%20tones%2C%20law%20office%20setting%2C%20high%20quality%20photography%2C%20simple%20and%20clean%20composition&width=400&height=280&seq=area-divorcio-001&orientation=landscape',
  },
  {
    icon: 'ri-parent-line',
    title: 'Guarda e Convivência',
    desc: 'Estratégias jurídicas voltadas ao bem-estar da criança.',
    image: 'https://readdy.ai/api/search-image?query=warm%20and%20tender%20parent%20and%20child%20hands%20together%20on%20soft%20beige%20background%2C%20gentle%20natural%20lighting%2C%20minimalist%20composition%2C%20emotional%20and%20caring%20atmosphere%2C%20high%20quality%20photography&width=400&height=280&seq=area-guarda-001&orientation=landscape',
  },
  {
    icon: 'ri-bank-card-2-line',
    title: 'Pensão Alimentícia',
    desc: 'Fixação, revisão ou exoneração de alimentos.',
    image: 'https://readdy.ai/api/search-image?query=elegant%20financial%20document%20and%20calculator%20on%20warm%20beige%20desk%2C%20soft%20lighting%2C%20minimalist%20professional%20setting%2C%20law%20office%20environment%2C%20clean%20composition%2C%20premium%20photography&width=400&height=280&seq=area-pensao-001&orientation=landscape',
  },
  {
    icon: 'ri-user-add-line',
    title: 'Paternidade',
    desc: 'Reconhecimento biológico e socioafetivo.',
    image: 'https://readdy.ai/api/search-image?query=father%20and%20child%20silhouette%20at%20sunset%2C%20warm%20golden%20tones%2C%20emotional%20and%20beautiful%20composition%2C%20soft%20focus%20background%2C%20family%20bond%2C%20elegant%20photography%20style%2C%20high%20quality&width=400&height=280&seq=area-paternidade-001&orientation=landscape',
  },
  {
    icon: 'ri-ancient-pavilion-line',
    title: 'Inventários e Testamentos',
    desc: 'Judicial e extrajudicial, com segurança e agilidade.',
    image: 'https://readdy.ai/api/search-image?query=antique%20law%20scroll%20and%20pen%20on%20elegant%20wooden%20desk%20with%20warm%20lighting%2C%20old%20document%20with%20gold%20seal%2C%20sophisticated%20legal%20setting%2C%20beige%20and%20golden%20tones%2C%20high%20quality%20photography&width=400&height=280&seq=area-inventario-001&orientation=landscape',
  },
  {
    icon: 'ri-building-2-line',
    title: 'Partilhas Patrimoniais',
    desc: 'Divisão justa de bens em separações e heranças.',
    image: 'https://readdy.ai/api/search-image?query=elegant%20modern%20house%20exterior%20with%20warm%20sunset%20light%2C%20minimalist%20architecture%2C%20soft%20beige%20tones%2C%20premium%20real%20estate%20photography%2C%20professional%20and%20sophisticated%20composition%2C%20high%20quality&width=400&height=280&seq=area-partilha-001&orientation=landscape',
  },
];

export default function PracticeAreas() {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="areas" ref={ref} className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div
          className={`text-center mb-16 transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
        >
          <div className="flex items-center justify-center gap-3 mb-5">
            <div className="h-px w-10 bg-chestnut"></div>
            <span className="text-chestnut text-xs tracking-[0.2em] uppercase font-sans font-medium">Especialidades</span>
            <div className="h-px w-10 bg-chestnut"></div>
          </div>
          <h2 className="font-serif text-ink-black text-3xl md:text-4xl font-semibold mb-4">
            Áreas de Atuação
          </h2>
          <p className="text-body-gray font-sans max-w-xl mx-auto text-base">
            Acompanhamento jurídico especializado em Direito de Família e Sucessões.
          </p>
        </div>

        {/* Cards: carousel on mobile, grid on desktop */}
        <div className="md:grid md:grid-cols-2 lg:grid-cols-3 md:gap-6 flex md:flex overflow-x-auto md:overflow-visible snap-x snap-mandatory md:snap-none gap-4 md:gap-6 pb-4 md:pb-0 -mx-5 md:mx-0 px-5 md:px-0">
          {areas.map((area, idx) => (
            <article
              key={area.title}
              className={`group bg-parchment rounded-xl overflow-hidden md:hover:-translate-y-1 transition-all duration-300 cursor-default flex-none w-[78vw] md:w-auto snap-start ${
                visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
              style={{ transitionDelay: `${idx * 80}ms` }}
            >
              {/* Card Image */}
              <div className="relative h-44 overflow-hidden">
                <img
                  src={area.image}
                  alt={area.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-ink-black/60 to-transparent"></div>
                <div className="absolute bottom-3 left-4 w-9 h-9 flex items-center justify-center bg-burnt-peach rounded-lg">
                  <i className={`${area.icon} text-white text-base`}></i>
                </div>
              </div>

              {/* Card Body */}
              <div className="p-5">
                <h3 className="font-serif text-ink-black text-lg font-semibold mb-1">{area.title}</h3>
                <p className="text-body-gray font-sans text-sm leading-relaxed">{area.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
